import _createForOfIteratorHelper from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export default {
  data: function data() {
    return {
      gameGroupList: [],
      originPkgTypeList: [],
      originPkgList: [] // appLoginTypeConfigDataNoPage:[],
      // appLoginTypeRes: [],
      // appPaymentTypeAllData: [],
      // appGatewayChannelListAllData: [],
      // appRealnameAuthConfigTypeDataAll:[],
      // appIAATypeAllData: [],
      // showStatus:[
      //   {
      //     lable:'显示',
      //     value:1
      //   },
      //   {
      //     lable:'不显示',
      //     value:2
      //   }
      // ],

    };
  },
  // activated() {
  //   if(this.$route.params.user_id){
  //     this.$nextTick(()=>{
  //       this.paramsData.appid = this.$route.params.appid
  //       this.paramsData.user_id = this.$route.params.user_id
  //       this.getList()
  //       this.$route.params.appid = ''
  //       this.$route.params.user_id = ''
  //     })
  //   }
  // },
  methods: {
    getcommonData: function getcommonData() {
      var _arguments = arguments,
          _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reqList, _iterator, _step, i, res;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reqList = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : [];
                _iterator = _createForOfIteratorHelper(reqList);
                _context.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context.next = 12;
                  break;
                }

                i = _step.value;
                _context.next = 8;
                return _this.$api[i]({
                  pageSize: 1000
                });

              case 8:
                res = _context.sent;
                _this[i] = res.data.data;

              case 10:
                _context.next = 4;
                break;

              case 12:
                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](2);

                _iterator.e(_context.t0);

              case 17:
                _context.prev = 17;

                _iterator.f();

                return _context.finish(17);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 14, 17, 20]]);
      }))();
    },
    getcommonDataNew: function getcommonDataNew() {
      var _arguments2 = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var reqList, _iterator2, _step2, i, res;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                reqList = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : [];
                _iterator2 = _createForOfIteratorHelper(reqList);
                _context2.prev = 2;

                _iterator2.s();

              case 4:
                if ((_step2 = _iterator2.n()).done) {
                  _context2.next = 12;
                  break;
                }

                i = _step2.value;
                _context2.next = 8;
                return _this2.$api[i]({
                  page_size: 1000
                });

              case 8:
                res = _context2.sent;
                _this2[i] = res.data.data;

              case 10:
                _context2.next = 4;
                break;

              case 12:
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](2);

                _iterator2.e(_context2.t0);

              case 17:
                _context2.prev = 17;

                _iterator2.f();

                return _context2.finish(17);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 14, 17, 20]]);
      }))();
    } // // 根据游戏ID获取登录类型
    // getLoginType(id){
    //   this.paramsData.o_type = ''
    //   this.$api.appLoginTypeConfigDataNoPage({appid:id, isMustAppid:2}).then(res=>{
    //     if(res.status == 200){
    //       this.appLoginTypeConfigDataNoPage = res.data  
    //     }
    //   })
    // }

  }
};